<div class="indicator-container animated" [ngClass]="{ 'swing bell': newCards > 0}" (click)="openNotifications()">
  <div class="news" [ngStyle]="indicatorStyle" *ngIf="newCards > 0">{{ newCards }}</div>
  <img [src]="notificacionIcon || '/assets/svg/white-bell.png'" alt="notificacion icon">
</div>